import React from "react";
import GenericEditForm from "../../components/GenericEditForm";

function EditClient() {
  return (
    <GenericEditForm
      title="Cliente"
      endpoint="/clients"
      backTo="/clients"
      fields={[
        {
          name: "name",
          label: "Nombre",
          type: "text",
          placeholder: "Nombre del cliente",
          required: true,
        },
        {
          name: "description",
          label: "Descripción",
          type: "textarea",
          placeholder: "Descripción del cliente",
          required: false,
        },
      ]}
    />
  );
}

export default EditClient;
